import React from 'react'
import { Card, Col, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';

const UserDetail = (props) => {
  return (
    <>
    <Modal {...props} aria-labelledby="contained-modal-title-vcenter" className='modalDrawer modalDrawerAdmin '>
        <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter" className='d-flex'>
                <div className="media-body">
                View User
                </div>
                <button className='cta' onClick={props.onHide}>Cancel</button>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body className="show-grid">
            <Card className='cardClientDetail'>
                <Card.Body>
                    <h3>Savannah Nguyen</h3>
                    <ul>
                        <li><i><Icon icon="mingcute:location-line" /></i><span>2972 Westheimer Rd. Santa Ana, Illinois 85486 </span></li>
                        <li><i><Icon icon="heroicons:envelope" /></i> <span>email@domain.com </span></li>
                    </ul>
                    <div>
                        <span className='badge badge-primary'>Client Ref: 4339</span>
                    </div>
                    {/*  // <div className="detail">
                    // <h4>Detail</h4>
                    // <p>At risus viverra adipiscing at in tellus. Blandit massa enim nec dui nunc mattis. Lacus vel facilisis volutpat est velit.</p>
    // </div> */}
                    <hr />
                    <div className="date">Created on: Thursday 25 Nov 2022</div>
                </Card.Body>
            </Card>
            <hr />
            <Card className='cardOptions'>
            <h3>Quick Options</h3>
                <Row>
                    <Col lg="6">
                        <Link to="#" className="media align-items-start">
                            <div className="icon"><Icon icon="akar-icons:edit" /></div>
                            <div className="media-body">
                            <h4>Edit</h4>
                            <p> 2972 Westheimer Rd. Santa Ana, Illinois 85486 </p>
                            </div>
                        </Link>
                    </Col>
                    <Col lg="6">
                    <Link to="#" className="media align-items-start">
                        <div className="icon"><Icon icon="fluent:document-bullet-list-20-regular" /></div>
                        <div className="media-body">
                        <h4>View Surveys</h4>
                        <p>View all associated surveys of this client</p>
                        </div>
                    </Link>
                </Col>
                <Col lg="6">
                <Link to="#" className="media align-items-start">
                    <div className="icon"><Icon icon="mingcute:delete-line" /></div>
                    <div className="media-body">
                    <h4>Delete</h4>
                    <p>Delete this client from your portal </p>
                    </div>
                </Link>
            </Col>
            <Col lg="6">
            <Link to="#" className="media align-items-start">
                <div className="icon"><i><Icon icon="heroicons:envelope" /></i></div>
                <div className="media-body">
                    <h4>Contact</h4>
                    <p>Contact this client through email.</p>
                </div>
            </Link>
        </Col>
                
                </Row>
            </Card>
        </Modal.Body>
    </Modal>
    </>
  )
}

export default UserDetail